import Transportation from "../components/pages/Transportation";

export default Transportation;
